import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { bookListURL as _bookListURL } from '@/constants';
import { getManualURL, getSupportURL } from '@/utils/manual';
import { useAuth } from '@/plugins/auth';
import { useDomain } from '@/plugins/domain';
import Icon from '@/components/renewal/common/icon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'help-menu-list',
  setup: function setup(__props) {
    var auth = useAuth();
    var domain = useDomain();
    var bookListURL = ref(_bookListURL);

    // マニュアルURL
    var manualLink = ref(null);
    var supportURL = ref(null);
    onMounted(function () {
      var pluginExtension = {
        $domain: domain,
        $auth: auth
      };
      manualLink.value = getManualURL(pluginExtension);
      supportURL.value = getSupportURL(pluginExtension);
    });
    return {
      __sfc: true,
      auth: auth,
      domain: domain,
      bookListURL: bookListURL,
      manualLink: manualLink,
      supportURL: supportURL,
      Icon: Icon
    };
  }
});